<template>
  <div>
    <el-card class="">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('menuCatalogManage.queryCondition') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="menuCatalogManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input
                v-model="menuCatalogManageInfo.conditions.name"
                :placeholder="$t('menuCatalogManage.enterMenuGroupName')"
                clearable
              />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select
                v-model="menuCatalogManageInfo.conditions.storeType"
                :placeholder="$t('menuCatalogManage.selectStoreType')"
                style="width:100%"
              >
                <el-option
                  :label="$t('menuCatalogManage.pleaseSelect')"
                  value=""
                />
                <el-option
                  :label="$t('menuCatalogManage.operationTeam')"
                  value="800900000001"
                />
                <el-option
                  :label="$t('menuCatalogManage.merchant')"
                  value="800900000005"
                />
                <el-option
                  :label="$t('menuCatalogManage.developmentTeam')"
                  value="800900000000"
                />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select
                v-model="menuCatalogManageInfo.conditions.isShow"
                :placeholder="$t('menuCatalogManage.selectIsShow')"
                style="width:100%"
              >
                <el-option
                  :label="$t('menuCatalogManage.pleaseSelect')"
                  value=""
                />
                <el-option
                  :label="$t('menuCatalogManage.yes')"
                  value="Y"
                />
                <el-option
                  :label="$t('menuCatalogManage.no')"
                  value="N"
                />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="_queryMenuCatalogMethod"
            >
              <i class="el-icon-search"></i>
              {{ $t('menuCatalogManage.query') }}
            </el-button>
            <el-button
              type="primary"
              size="small"
              @click="_resetMenuCatalogMethod"
            >
              <i class="el-icon-refresh"></i>
              {{ $t('menuCatalogManage.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('menuCatalogManage.menuCatalog') }}</span>
        <el-button
          type="primary"
          size="small"
          style="float:right"
          @click="_openAddMenuCatalogModal"
        >
          <i class="el-icon-plus"></i>
          {{ $t('menuCatalogManage.add') }}
        </el-button>
      </div>
      <div class="">
        <el-table
          :data="menuCatalogManageInfo.menuCatalogs"
          border
          style="width:100%"
        >
          <el-table-column
            prop="caId"
            :label="$t('menuCatalogManage.number')"
            align="center"
          />
          <el-table-column
            prop="name"
            :label="$t('menuCatalogManage.menuGroupName')"
            align="center"
          />
          <el-table-column
            prop="icon"
            :label="$t('menuCatalogManage.icon')"
            align="center"
          />
          <el-table-column
            prop="seq"
            :label="$t('menuCatalogManage.sequence')"
            align="center"
          />
          <el-table-column
            prop="storeType"
            :label="$t('menuCatalogManage.storeType')"
            align="center"
          >
            <template slot-scope="scope">
              {{ _getStoreTypeName(scope.row.storeType) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="url"
            :label="$t('menuCatalogManage.page')"
            align="center"
          />
          <el-table-column
            prop="isShow"
            :label="$t('menuCatalogManage.isShow')"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.isShow == 'Y' ? $t('menuCatalogManage.yes') : $t('menuCatalogManage.no') }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('menuCatalogManage.operation')"
            align="center"
            width="300"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="_openEditMenuCatalogModel(scope.row)"
              >
                {{ $t('menuCatalogManage.edit') }}
              </el-button>
              <el-button
                size="mini"
                @click="_openMenuCatalogGroup(scope.row)"
              >
                {{ $t('menuCatalogManage.menuGroup') }}
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="_openDeleteMenuCatalogModel(scope.row)"
              >
                {{ $t('menuCatalogManage.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total"
          style="margin-top:20px;text-align:right"
        />
      </div>
    </el-card>

    <add-menu-catalog ref="addMenuCatalog" @refresh="_listMenuCatalogs" />
    <edit-menu-catalog ref="editMenuCatalog" @refresh="_listMenuCatalogs" />
    <delete-menu-catalog ref="deleteMenuCatalog" @refresh="_listMenuCatalogs" />
  </div>
</template>

<script>
import { listMenuCatalog } from '@/api/dev/menuCatalogApi'
import AddMenuCatalog from '@/components/dev/addMenuCatalog/addMenuCatalog'
import EditMenuCatalog from '@/components/dev/editMenuCatalog/editMenuCatalog'
import DeleteMenuCatalog from '@/components/dev/deleteMenuCatalog/deleteMenuCatalog'

export default {
  name: 'MenuCatalogManage',
  components: {
    AddMenuCatalog,
    EditMenuCatalog,
    DeleteMenuCatalog
  },
  data() {
    return {
      menuCatalogManageInfo: {
        menuCatalogs: [],
        total: 0,
        records: 1,
        conditions: {
          name: '',
          seq: '',
          isShow: '',
          storeType: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listMenuCatalogs(this.currentPage, this.pageSize)
  },
  methods: {
    async _listMenuCatalogs(page, rows) {
      try {
        const params = {
          page,
          row: rows,
          ...this.menuCatalogManageInfo.conditions
        }
        const res = await listMenuCatalog(params)
        this.menuCatalogManageInfo.menuCatalogs = res.data
        this.menuCatalogManageInfo.total = res.total
        this.menuCatalogManageInfo.records = res.records
      } catch (error) {
        console.error(error)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listMenuCatalogs(this.currentPage, this.pageSize)
    },
    _openAddMenuCatalogModal() {
      this.$refs.addMenuCatalog.open()
    },
    _openEditMenuCatalogModel(row) {
      this.$refs.editMenuCatalog.open(row)
    },
    _openDeleteMenuCatalogModel(row) {
      this.$refs.deleteMenuCatalog.open(row)
    },
    _queryMenuCatalogMethod() {
      this.currentPage = 1
      this._listMenuCatalogs(this.currentPage, this.pageSize)
    },
    _resetMenuCatalogMethod() {
      this.menuCatalogManageInfo.conditions = {
        name: '',
        storeType: '',
        isShow: ''
      }
      this.currentPage = 1
      this._listMenuCatalogs(this.currentPage, this.pageSize)
    },
    _openMenuCatalogGroup(row) {
      this.$router.push({
        path: '/pages/dev/menuGroupCatalogManage',
        query: {
          caId: row.caId,
          storeType: row.storeType,
          catalogName: row.name
        }
      })
    },
    _getStoreTypeName(storeTypeCd) {
      const map = {
        '800900000001': this.$t('menuCatalogManage.operationTeam'),
        '800900000002': this.$t('menuCatalogManage.agent'),
        '800900000004': this.$t('menuCatalogManage.logisticsCompany'),
        '800900000005': this.$t('menuCatalogManage.merchant'),
        '800900000000': this.$t('menuCatalogManage.developmentTeam'),
        '800900000006': this.$t('menuCatalogManage.runErrands')
      }
      return map[storeTypeCd] || this.$t('menuCatalogManage.unknown')
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>